var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.permissionsLoaded)?_c('app-container',[_c('router-view',{staticClass:"main-content",attrs:{"slot":"main-content"},slot:"main-content"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }